/** Interpayments surcharge cancel certification reason codes */
export const InterpaymentsCancelReasonCode = {
  Abandoned: "ABANDONED",
  SwitchedPaymentToAch: "SWITCHED_PAYMENT_TO_ACH",
  SwitchedPaymentToCash: "SWITCHED_PAYMENT_TO_CASH",
  Other: "OTHER",
} as const;

export type HasOptionalSalesTransactionId = {
  SalesTransactionId?: string | null;
};

/** Distinct non-empty sTxIds from surcharge quote API details */
export function collectSurchargeSalesTransactionIds(
  details?: HasOptionalSalesTransactionId[] | null,
): string[] {
  const set = new Set<string>();
  for (const d of details ?? []) {
    const id = d.SalesTransactionId;
    if (id) set.add(id);
  }
  return [...set];
}
